/**
 * TRANSLATIONS FILE
 * =================
 * Contains all text strings for English and Arabic languages.
 * Add new translations here as the app grows.
 */

export const translations = {
  en: {
    // Navigation
    dashboard: 'Dashboard',
    operationsCenter: 'Operations Center',
    dailyTasks: 'Daily Tasks',
    fleetTracker: 'Fleet Tracker',
    fleetCommand: 'Fleet Command',
    companyInfo: 'Company Info',
    portals: 'Portals',
    messenger: 'Messenger',
    vacation: 'Vacation',
    leaveApprovals: 'Leave Approvals',
    importCSV: 'Import CSV',
    downloadTemplate: 'Download Template',
    bulkImport: 'Bulk Import',
    profile: 'Profile',
    activityLog: 'Activity Log',
    monthlyPO: 'Monthly PO',
    timesheets: 'Timesheets',
    selfService: 'Self Service',
    shifts: 'Shift Schedule',
    announcements: 'Announcements',
    nurseDocs: 'Nurse Documents',
    doctorDocs: 'Doctor Documents',
    driverDocs: 'Driver Documents',
    reports: 'Reports',
    hr: 'Human Resources',
    signOut: 'Sign Out',
    home: 'Home',
    back: 'Back',
    
    // Dashboard
    welcomeBack: 'Welcome Back',
    totalContracts: 'Total Contracts',
    activeContracts: 'Active Contracts',
    totalValue: 'Total Value',
    purchaseOrders: 'Purchase Orders',
    pendingOrders: 'Pending Orders',
    expiringContracts: 'Expiring Contracts',
    recentActivity: 'Recent Activity',
    overview: 'Overview',
    analytics: 'Analytics',
    dashboardSubtitle: 'Monitor your operations at a glance',
    contractsTrend: 'Contracts Trend',
    valueDistribution: 'Value Distribution',
    healthOverview: 'Health Overview',
    monthlyComparison: 'Monthly Comparison',
    quickStats: 'Quick Stats',
    
    // Operations Center
    contracts: 'Contracts',
    addContract: 'Add Contract',
    editContract: 'Edit Contract',
    deleteContract: 'Delete Contract',
    contractDetails: 'Contract Details',
    company: 'Company',
    contactName: 'Contact Name',
    contactEmail: 'Contact Email',
    startDate: 'Start Date',
    endDate: 'End Date',
    status: 'Status',
    health: 'Health',
    value: 'Value',
    actions: 'Actions',
    operationsCenterDesc: 'Manage contracts and purchase orders with enterprise-grade precision',
    contractManagement: 'Contract Management',
    contractsRegistered: 'contracts registered',
    newContract: 'New Contract',
    newContractEntry: 'New Contract Entry',
    identification: 'Identification',
    serialNumber: 'Serial Number',
    idCode: 'ID Code',
    contact: 'Contact',
    dates: 'Dates',
    valueSar: 'Value (SAR)',
    document: 'Document',
    uploadDocument: 'Upload Document',
    noDocument: 'No document attached',
    exportCsv: 'Export CSV',
    viewDetails: 'View Details',
    closeDetails: 'Close Details',
    
    // Purchase Orders
    addPurchaseOrder: 'Add Purchase Order',
    vendorParty: 'Vendor Party',
    siteLocation: 'Site Location',
    contactInfo: 'Contact Info',
    locationType: 'Location Type',
    purchaseOrderManagement: 'Purchase Orders',
    ordersRegistered: 'orders registered',
    newPo: 'New PO',
    newPurchaseOrder: 'New Purchase Order',
    vendorInformation: 'Vendor Information',
    locationStatus: 'Location & Status',
    category: 'Category',
    
    // Fleet Tracker
    fleetOverview: 'Fleet Overview',
    totalFleet: 'Total Fleet',
    activeUnits: 'Active Units',
    standbyUnits: 'Standby Units',
    utilization: 'Utilization',
    searchResources: 'Search resources...',
    allTypes: 'All Types',
    allStatuses: 'All Statuses',
    realTimeTracking: 'Real-time resource tracking & mobilization',
    live: 'LIVE',
    deployResource: 'Deploy Resource',
    totalResources: 'Total Resources',
    activeDeployed: 'Active / Deployed',
    onStandby: 'On Standby',
    realtimeSync: 'Real-time sync',
    deployNewResource: 'Deploy New Resource',
    resourceType: 'Resource Type',
    nameId: 'Name / ID',
    assignment: 'Assignment',
    latitude: 'Latitude',
    longitude: 'Longitude',
    dragToUpdate: 'KSA Region • Drag markers to update locations',
    
    // Fleet Command
    personnelManagement: 'Personnel Management',
    drilling: 'Drilling',
    construction: 'Construction',
    marineSupport: 'Vessel',
    onshore: 'Onshore',
    offshore: 'Offshore',
    addPersonnel: 'Add Personnel',
    editPersonnel: 'Edit Personnel',
    name: 'Name',
    idNumber: 'ID Number',
    role: 'Role',
    shift: 'Shift',
    dayShift: 'Day Shift',
    nightShift: 'Night Shift',
    certificationStatus: 'Certification Status',
    approved: 'Approved',
    nonApproved: 'Non-Approved',
    mobilizationDate: 'Mobilization Date',
    demobilizationDate: 'Demobilization Date',
    mobilized: 'Mobilized',
    demobilized: 'Demobilized',
    personnelTimeline: 'Personnel & Timeline Management System',
    tableView: 'Table',
    timelineView: 'Timeline',
    searchNameIdRole: 'Search name, ID, role...',
    allShifts: 'All Shifts',
    allStatus: 'All Status',
    clear: 'Clear',
    refresh: 'Refresh',
    commandCenter: 'Command Center',
    headcountByShift: 'Headcount by Shift',
    recentMobilizations: 'Recent Mobilizations',
    
    // Messenger
    messages: 'Messages',
    typeMessage: 'Type a message...',
    online: 'Online',
    offline: 'Offline',
    onlineUsers: 'Online Users',
    noMessages: 'No messages yet',
    startConversation: 'Start a conversation',
    searchUsers: 'Search users...',
    searchConversations: 'Search conversations...',
    welcomeToMessenger: 'Welcome to Messenger',
    selectConversation: 'Select a conversation from the list or start a new chat to begin messaging with your contacts.',
    startNewChat: 'Start New Chat',
    muteNotifications: 'Mute notifications',
    unmuteNotifications: 'Unmute notifications',
    chatWallpaper: 'Chat wallpaper',
    sendMessage: 'Send Message',
    voiceMessage: 'Voice Message',
    attachFile: 'Attach File',
    shareLocation: 'Share Location',
    replyTo: 'Reply to',
    forwardMessage: 'Forward Message',
    deleteMessage: 'Delete Message',
    editMessage: 'Edit Message',
    starMessage: 'Star Message',
    copyMessage: 'Copy Message',
    
    // Profile
    accountSettings: 'Account Settings',
    username: 'Username',
    email: 'Email',
    changePassword: 'Change Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    twoFactorAuth: 'Two-Factor Authentication',
    deleteAccount: 'Delete Account',
    signOutAllDevices: 'Sign Out All Devices',
    profileSettings: 'Profile Settings',
    securitySettings: 'Security Settings',
    notificationSettings: 'Notification Settings',
    updateProfile: 'Update Profile',
    uploadAvatar: 'Upload Avatar',
    removeAvatar: 'Remove Avatar',
    activeSessions: 'Active Sessions',
    sessionManagement: 'Session Management',
    
    // Vacation & Leave
    vacationRequests: 'Vacation Requests',
    requestVacation: 'Request Vacation',
    newVacationRequest: 'New Vacation Request',
    leaveType: 'Leave Type',
    annual: 'Annual',
    sick: 'Sick',
    emergency: 'Emergency',
    reason: 'Reason',
    numberOfDays: 'Number of Days',
    daysRemaining: 'Days Remaining',
    daysUsed: 'Days Used',
    totalDays: 'Total Days',
    leaveBalance: 'Leave Balance',
    approvedRequests: 'Approved Requests',
    pendingRequests: 'Pending Requests',
    declinedRequests: 'Declined Requests',
    managerNotes: 'Manager Notes',
    approve: 'Approve',
    decline: 'Decline',
    submitRequest: 'Submit Request',
    cancelRequest: 'Cancel Request',
    viewRequest: 'View Request',
    requestDetails: 'Request Details',
    requestedBy: 'Requested By',
    requestedOn: 'Requested On',
    reviewedBy: 'Reviewed By',
    reviewedOn: 'Reviewed On',
    
    // Timesheets
    timesheetManagement: 'Timesheet Management',
    submitTimesheet: 'Submit Timesheet',
    viewTimesheet: 'View Timesheet',
    timesheetPeriod: 'Timesheet Period',
    hoursWorked: 'Hours Worked',
    overtime: 'Overtime',
    regularHours: 'Regular Hours',
    totalHours: 'Total Hours',
    timesheetStatus: 'Timesheet Status',
    submitted: 'Submitted',
    underReview: 'Under Review',
    rejected: 'Rejected',
    notes: 'Notes',
    attachments: 'Attachments',
    downloadTimesheet: 'Download Timesheet',
    uploadTimesheet: 'Upload Timesheet',
    
    // Daily Tasks
    dailyWorkPlan: 'Daily Work Plan',
    addTask: 'Add Task',
    editTask: 'Edit Task',
    deleteTask: 'Delete Task',
    taskDetails: 'Task Details',
    clientName: 'Client Name',
    clientContact: 'Client Contact',
    subject: 'Subject',
    deadline: 'Deadline',
    assignedTo: 'Assigned To',
    priority: 'Priority',
    high: 'High',
    medium: 'Medium',
    low: 'Low',
    taskStatus: 'Task Status',
    inProgress: 'In Progress',
    onHold: 'On Hold',
    won: 'Won',
    quotation: 'Quotation',
    siteVisit: 'Site Visit',
    officeWork: 'Office Work',
    meeting: 'Meeting',
    quotationValue: 'Quotation Value',
    quotationReference: 'Quotation Reference',
    quoteStatus: 'Quote Status',
    sent: 'Sent',
    closed: 'Closed',
    accepted: 'Accepted',
    waiting: 'Waiting',
    participated: 'Participated',
    taskNumber: 'Task Number',
    dateCompleted: 'Date Completed',
    reminder: 'Reminder',
    
    // Monthly PO
    monthlyPoTracking: 'Monthly PO Tracking',
    addTrack: 'Add Track',
    editTrack: 'Edit Track',
    deleteTrack: 'Delete Track',
    serviceName: 'Service Name',
    locationName: 'Location Name',
    quantity: 'Quantity',
    poNumber: 'PO Number',
    buyerName: 'Buyer Name',
    buyerEmail: 'Buyer Email',
    sentToFinance: 'Sent to Finance',
    justification: 'Justification',
    month: 'Month',
    year: 'Year',
    calendarView: 'Calendar View',
    gridView: 'Grid View',
    poFile: 'PO File',
    timesheetFile: 'Timesheet File',
    
    // Activity Log
    activityHistory: 'Activity History',
    action: 'Action',
    tableName: 'Table Name',
    recordId: 'Record ID',
    oldData: 'Old Data',
    newData: 'New Data',
    timestamp: 'Timestamp',
    performedBy: 'Performed By',
    insert: 'Insert',
    update: 'Update',
    
    // Company Documents
    companyDocuments: 'Company Documents',
    documentName: 'Document Name',
    issuedDate: 'Issued Date',
    expiryDate: 'Expiry Date',
    documentStatus: 'Document Status',
    documentHealth: 'Document Health',
    uploadFile: 'Upload File',
    viewFile: 'View File',
    downloadFile: 'Download File',
    
    // Portal Users
    portalUsers: 'Portal Users',
    websiteUrl: 'Website URL',
    password: 'Password',
    showPassword: 'Show Password',
    hidePassword: 'Hide Password',
    copyPassword: 'Copy Password',
    government: 'Government',
    private: 'Private',
    
    // Common
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    filter: 'Filter',
    export: 'Export',
    import: 'Import',
    loading: 'Loading...',
    noData: 'No data available',
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
    close: 'Close',
    submit: 'Submit',
    reset: 'Reset',
    apply: 'Apply',
    selectAll: 'Select All',
    deselectAll: 'Deselect All',
    showMore: 'Show More',
    showLess: 'Show Less',
    viewAll: 'View All',
    noResults: 'No results found',
    tryAgain: 'Try Again',
    goBack: 'Go Back',
    next: 'Next',
    previous: 'Previous',
    first: 'First',
    last: 'Last',
    page: 'Page',
    of: 'of',
    items: 'items',
    selected: 'selected',
    all: 'All',
    none: 'None',
    
    // Status
    valid: 'Valid',
    expired: 'Expired',
    healthy: 'Healthy',
    atRisk: 'At Risk',
    critical: 'Critical',
    active: 'Active',
    standby: 'Standby',
    pending: 'Pending',
    completed: 'Completed',
    overdue: 'Overdue',
    
    // Roles & Fleet Types
    nurse: 'Nurse',
    doctor: 'Doctor',
    clinic: 'Clinic',
    driver: 'Driver',
    ambulance: 'Ambulance',
    management: 'Management',
    operations: 'Operations',
    declined: 'Declined',
    
    // Time
    today: 'Today',
    yesterday: 'Yesterday',
    lastWeek: 'Last Week',
    lastMonth: 'Last Month',
    thisMonth: 'This Month',
    thisYear: 'This Year',
    dateRange: 'Date Range',
    from: 'From',
    to: 'To',
    
    // Auth
    signIn: 'Sign In',
    signUp: 'Sign Up',
    forgotPassword: 'Forgot Password?',
    rememberMe: 'Remember Me',
    welcomeTo: 'Welcome to',
    enterprise: 'Enterprise',
    workManagement: 'Work Management',
    fleetPersonnel: 'Fleet & Personnel',
    companyAdmin: 'Company & Admin',
    employeeHub: 'Employee Hub',
    createAccount: 'Create Account',
    alreadyHaveAccount: 'Already have an account?',
    dontHaveAccount: "Don't have an account?",
    resetPassword: 'Reset Password',
    sendResetLink: 'Send Reset Link',
    backToLogin: 'Back to Login',
    verifyEmail: 'Verify Email',
    resendCode: 'Resend Code',
    enterCode: 'Enter Code',
    trustThisDevice: 'Trust this device',
    
    // Notifications
    notifications: 'Notifications',
    markAsRead: 'Mark as Read',
    markAllAsRead: 'Mark All as Read',
    clearAll: 'Clear All',
    noNotifications: 'No notifications',
    newNotification: 'New Notification',
    
    // Errors
    somethingWentWrong: 'Something went wrong',
    pageNotFound: 'Page not found',
    accessDenied: 'Access denied',
    sessionExpired: 'Session expired',
    networkError: 'Network error',
    pleaseTryAgain: 'Please try again',
    
    // Success Messages
    savedSuccessfully: 'Saved successfully',
    deletedSuccessfully: 'Deleted successfully',
    updatedSuccessfully: 'Updated successfully',
    createdSuccessfully: 'Created successfully',
    
    // Dashboard Extended
    enterpriseIntelligence: 'Enterprise Intelligence',
    realTimeAnalytics: 'Real-time analytics and insights for informed decision-making',
    totalContractValue: 'Total Contract Value',
    totalPOValue: 'Total PO Value',
    purchaseOrderTrends: 'Purchase Order Trends',
    lastSixMonths: 'Last 6 months performance',
    contractHealthTitle: 'Contract Health',
    currentStatusOverview: 'Current status overview',
    timesheetReview: 'Timesheet Review',
    overallReviewStatus: 'Overall review status',
    approvalRate: 'Approval Rate',
    noTrendData: 'No trend data available',
    noContractData: 'No contract data available',
    total: 'Total',
    
    // Monthly PO Extended
    monthlyPurchaseOrderPlanner: 'Monthly Purchase Order Planner',
    masterPlanningGrid: 'Master planning grid for tracking POs across all locations and services',
    totalLocations: 'Total Locations',
    missingPoAlerts: 'Missing PO Alerts',
    sharedWithFinance: 'Shared with Finance',
    searchPlaceholder: 'Search location, service, company, or PO number...',
    allLocations: 'All Locations',
    missingPoFile: 'Missing PO File',
    pendingFinance: 'Pending Finance',
    clearFilters: 'Clear filters',
    noDataToExport: 'No data to export',
    excelDownloaded: 'Excel file downloaded',
    pdfOpened: 'PDF opened for printing',
    
    // Vacation Extended
    myVacation: 'My Vacation',
    manageTimeOff: 'Manage your time off requests',
    newRequest: 'New Request',
    daysAway: 'days away',
    noUpcomingLeave: 'No upcoming leave',
    requestHistory: 'Request History',
    noVacationHistory: 'No vacation history',
    noVacationRequestsYet: "You haven't submitted any vacation requests yet.",
    submitFirstRequest: 'Submit your first request',
    awaitingApproval: 'Awaiting approval',
    nextLeave: 'Next Leave',
    days: 'days',
    cancelVacationRequest: 'Cancel Vacation Request?',
    keepRequest: 'Keep Request',
    cancelling: 'Cancelling...',
    requestCancelled: 'Request Cancelled',
    vacationRequestCancelled: 'Your vacation request has been cancelled.',
    
    // Confirmations
    areYouSure: 'Are you sure?',
    thisActionCannotBeUndone: 'This action cannot be undone',
    confirmDelete: 'Confirm Delete',
    confirmAction: 'Confirm Action',
    
    // Contracts Module
    totalContractValueKpi: 'Total Contract Value',
    expiringSoon: 'Expiring Soon',
    pendingRenewals: 'Pending Renewals',
    timeline: 'Timeline',
    needsReview: 'Needs Review',
    expiringLabel: 'Expiring Soon',
    contractsLabel: 'contracts',
    fromLastMonth: 'from last month',
    
    // Purchase Orders Module
    totalOrderValue: 'Total Order Value',
    pendingFulfillment: 'Pending Fulfillment',
    invoicedPaid: 'Invoiced / Paid',
    totalPoValue: 'Total PO Value',
    ordersLabel: 'orders',
    fulfillment: 'Fulfillment',
    vendor: 'Vendor',
    type: 'Type',
    doc: 'Doc',
    
    // Timesheets Extended
    pendingTimesheets: 'Pending',
    historyTimesheets: 'History',
    allTimesheets: 'All',
    overdueTimesheets: 'Overdue',
    timesheetApproved: 'Approved',
    timesheetRejected: 'Rejected',
    timesheetPending: 'Pending',
    resetToPending: 'Reset to Pending',
    resource: 'Resource',
    period: 'Period',
    receivedOn: 'Received On',
    requestHelp: 'Request Help',
    manualRequest: 'Manual Request',
    selectResource: 'Select Resource',
    selectType: 'Select Type',
    monthlyCycle: 'Monthly Cycle',
    demobilization: 'Demobilization',
    filterByRole: 'Filter by Role',
    helpDescription: 'Please describe your issue or request in detail.',
    phone: 'Phone',
    
    // Daily Tasks Extended
    dailyTaskWorkPlan: 'Daily Task & Work Plan',
    manageTrackTasks: 'Manage and track all tasks, quotations, and work assignments',
    criticalTasks: 'Critical Tasks',
    quotationPipeline: 'Quotation Pipeline',
    completionRate: 'Completion Rate',
    totalActiveTasks: 'Total Active Tasks',
    urgent: 'urgent',
    allClear: 'All clear',
    onTrack: 'On track',
    needsAttention: 'Needs attention',
    totalLabel: 'total',
    searchTasksCompanies: 'Search tasks, companies, or IDs...',
    filterByStatus: 'Filter by Status',
    filterByAssignee: 'Filter by Assignee',
    allAssignees: 'All Assignees',
    noTasksFound: 'No tasks found',
    createFirstTask: 'Create your first task',
    taskId: 'Task ID',
    taskInfo: 'Task Info',
    daysLeft: 'Days Left',
    files: 'Files',
    loadingTasks: 'Loading tasks...',
    table: 'Table',
    kanban: 'Kanban',
    unassigned: 'Unassigned',
    
    // Fleet Resources Extended
    fleetResources: 'Fleet Resources',
    manageFleetResources: 'Manage and add fleet resources',
    addResource: 'Add Resource',
    editResource: 'Edit Resource',
    addNewResource: 'Add New Resource',
    resourceAdded: 'Resource Added',
    newFleetResourceAdded: 'New fleet resource has been added.',
    resourceUpdated: 'Resource Updated',
    fleetResourceUpdated: 'Fleet resource has been updated.',
    resourceRemoved: 'Resource Removed',
    fleetResourceRemoved: 'Fleet resource has been removed.',
    confirmDeleteResource: 'Are you sure you want to delete this resource?',
    statusUpdated: 'Status Updated',
    resourceNow: 'Resource is now',
    validationError: 'Validation Error',
    allResources: 'All Resources',
    noMatchingResources: 'No matching resources found',
    noResourcesYet: 'No resources added yet',
    noResourcesDeployed: 'No resources deployed',
    detailsLabel: 'Details',
    detailsAssignment: 'Details / Assignment',
    optional: 'optional',
    egDrSmith: 'e.g., Dr. Smith',
    egSiteAlpha: 'e.g., Site Alpha',
    updateResource: 'Update Resource',
    deployedResources: 'Deployed Resources',
    personnelAssigned: 'Personnel',
    noPersonnelAssigned: 'No personnel assigned',
    lastUpdated: 'Last Update',

    // Auth & Security extended
    securityCheckRequired: 'Security Check Required',
    pleaseCompleteRecaptcha: 'Please complete the reCAPTCHA verification',
    securityCheckFailed: 'Security Check Failed',
    recaptchaVerifyFailed: 'reCAPTCHA verification failed. Please try again.',
    unableToVerifyRecaptcha: 'Unable to verify reCAPTCHA. Please try again.',
    pleaseEnterValidEmail: 'Please enter a valid email address',
    invalidUsernameTitle: 'Invalid Username',
    tooManyAttempts: 'Too Many Attempts',
    loginFailed: 'Login Failed',
    welcomeBackToast: 'Welcome back!',
    signedInTrustedDevice: 'Signed in from trusted device.',
    twoFARequired: '2FA Required',
    enterCodeFromAuthenticator: 'Enter the code from your authenticator app',
    youHaveSuccessfullyLoggedIn: 'You have successfully logged in.',
    signUpFailed: 'Sign Up Failed',
    accountCreated: 'Account Created!',
    signedInAutomatically: 'You have been signed in automatically.',
    deviceRemembered: 'Device Remembered',
    no2FAFor30Days: "You won't need 2FA on this device for 30 days.",
    unexpectedErrorOccurred: 'An unexpected error occurred',
    accessYourAccount: 'Access your account',
    createAccountHeading: 'Create account',
    enterCredentialsToContinue: 'Enter your credentials to continue',
    fillDetailsToGetStarted: 'Fill in the details to get started',
    warningAttemptsRemaining: 'Warning: {count} attempt(s) remaining before lockout',
    yourUsername: 'Your username',
    emailAddressLabel: 'Email Address',
    emailPlaceholderExample: 'you@company.com',
    slideToSignIn: 'Slide to Sign In',
    createAccountButton: 'Create Account',
    dontHaveAccountSignUp: "Don't have an account?",
    alreadyHaveAccountSignIn: 'Already have an account?',
    enterpriseExcellence: 'Enterprise Excellence',
    secureIntelligentModern: 'Secure Intelligent Modern',
    secureManagementSubtitle: 'Secure, intelligent management for contracts, purchase orders, and fleet operations.',
    returnToHome: 'Return to Home',

    // 2FA Verify
    twoFactorAuthTitle: 'Two-Factor Authentication',
    enterBackupCode: 'Enter one of your backup codes',
    enter6DigitCode: 'Enter the 6-digit code from your authenticator app',
    codeRefreshesIn: 'Code refreshes in',
    openAuthenticatorApp: 'Open your authenticator app (Google Authenticator, Authy, etc.) to get your code.',
    enterBackupCodesSaved: 'Enter one of the backup codes you saved when setting up 2FA.',
    rememberDevice30Days: 'Remember this device for 30 days',
    verifyAndSignIn: 'Verify & Sign In',
    useAuthenticatorCode: 'Use authenticator code',
    useBackupCode: 'Use backup code',
    verified: 'Verified!',
    backupCodeUsedGenerateNew: 'Backup code used. Consider generating new backup codes.',
    invalidCode: 'Invalid Code',
    pleaseCheckCodeTryAgain: 'Please check your code and try again',
    tooManyAttemptsTryAgainLater: 'Please try again later',

    // 2FA Setup
    notAuthenticated: 'Not authenticated',
    twoFASetupStarted: '2FA Setup Started',
    scanQRWithAuthenticator: 'Scan the QR code with your authenticator app',
    twoFAEnabledToast: '2FA Enabled!',
    twoFactorNowActive: 'Two-factor authentication is now active on your account',
    invalidCodeCheckAuthenticator: 'Please check your authenticator app and try again',
    twoFADisabled: '2FA Disabled',
    twoFARemovedFromAccount: 'Two-factor authentication has been removed from your account',
    copied: 'Copied!',
    backupCodesCopiedToClipboard: 'Backup codes copied to clipboard',
    enabledAndProtecting: '✓ Enabled and protecting your account',
    disable: 'Disable',
    disableTwoFactorQuestion: 'Disable Two-Factor Authentication?',
    disable2FADescription: 'This will remove an important security layer from your account. Anyone with your password will be able to access your account.',
    yesDisable2FA: 'Yes, disable 2FA',
    copyBackupCodesLabel: 'Copy backup codes',
    setupAuthenticatorApp: 'Setup Authenticator App',
    scanQRWithGoogleAuthy: 'Scan the QR code with Google Authenticator or Authy',
    cantScanEnterManually: "Can't scan? Enter this code manually:",
    saveYourBackupCodes: 'Save your backup codes',
    copyAll: 'Copy all',
    storeBackupCodesSafely: 'Store these codes safely. Each code can only be used once if you lose access to your authenticator.',
    enter6DigitToVerify: 'Enter the 6-digit code from your authenticator app to verify:',
    verifyAndEnable: 'Verify & Enable',
    addExtraLayerSecurity: 'Add an extra layer of security with TOTP',
    enable2FA: 'Enable 2FA',

    // Forgot password
    pleaseCompleteSecurityVerification: 'Please complete the security verification',
    securityVerificationFailed: 'Security verification failed. Please try again.',
    unableToVerifySecurityCheck: 'Unable to verify security check. Please try again.',
    emailSent: 'Email Sent',
    checkInboxForResetLink: 'Check your inbox for the password reset link.',
    failedToSendResetEmail: 'Failed to send reset email',
    checkYourEmail: 'Check Your Email',
    ifAccountExistsResetLink: "If an account exists with this email, you'll receive a password reset link shortly.",
    enterEmailResetLink: "Enter your email address and we'll send you a link to reset your password.",

    // Reset password page
    invalidOrExpiredResetLink: 'Invalid or expired reset link. Please request a new password reset.',
    passwordsDoNotMatch: 'Passwords do not match',
    passwordUpdated: 'Password Updated',
    passwordResetSuccessfully: 'Password Reset Successful',
    youWillBeRedirected: 'You will be redirected to the login page shortly.',
    resetYourPassword: 'Reset Your Password',
    enterNewPasswordBelow: 'Enter your new password below',
    min8CharsPassword: 'Min 8 characters with uppercase, lowercase, and number',
    failedToResetPassword: 'Failed to reset password',

    // NotFound
    oopsPageNotFound: 'Oops! Page not found',

    // Profile extended
    pleaseSelectImageFile: 'Please select an image file',
    imageMustBeLessThan2MB: 'Image must be less than 2MB',
    avatarUpdated: 'Avatar Updated',
    profilePictureUpdated: 'Your profile picture has been updated.',
    avatarRemoved: 'Avatar Removed',
    profilePictureRemoved: 'Your profile picture has been removed.',
    usernameCannotBeEmpty: 'Username cannot be empty',
    profileUpdated: 'Profile Updated',
    profileSavedSuccessfully: 'Your profile has been saved successfully.',
    newPasswordsDoNotMatch: 'New passwords do not match',
    passwordMustBe6Chars: 'Password must be at least 6 characters',
    passwordChanged: 'Password Changed',
    passwordUpdatedSuccessfully: 'Your password has been updated successfully.',
    accountDeleted: 'Account Deleted',
    accountPermanentlyDeleted: 'Your account has been permanently deleted.',
    signedOut: 'Signed Out',
    signedOutAllDevices: 'You have been signed out from all devices.',
    aiAssistantEnabled: 'AI Assistant enabled',
    aiAssistantDisabled: 'AI Assistant disabled',
    editProfile: 'Edit Profile',
    removePhoto: 'Remove photo',
    securityAndLogin: 'Security & Login',
    updatePasswordRegularly: 'Update your password regularly to stay safe.',
    enterNewPassword: 'Enter new password',
    confirmNewPasswordPlaceholder: 'Confirm new password',
    changePasswordButton: 'Change Password',
    personalInformation: 'Personal Information',
    emailCannotBeChanged: 'Email cannot be changed',
    iqamaId: 'Iqama ID',
    enterIqamaId: 'Enter your Iqama ID',
    requiredForPayrollLeave: 'Required for payroll and leave records',
    interfacePreferences: 'Interface Preferences',
    enableAIAssistant: 'Enable AI Assistant',
    showFloatingAIChat: 'Show the floating AI chat button for quick help.',
    deleteAccountLabel: 'Delete Account',
    permanentlyRemoveAccount: 'Permanently remove your account and all data.',
    deleteAccountButton: 'Delete Account',
    areYouAbsolutelySure: 'Are you absolutely sure?',
    deleteAccountPermanentWarning: 'This action cannot be undone. This will permanently delete your account and remove all your data from our servers.',
    yesDeleteMyAccount: 'Yes, delete my account',
    signOutAll: 'Sign Out All',
    logOutFromAllSessions: 'Log out from all sessions across all devices.',
    activeSessionsTitle: 'Active Sessions',
    your5MostRecentSessions: 'Your 5 most recent active sessions',
    noActiveSessionsFound: 'No active sessions found',
    currentSession: 'Current',
    lastActive: 'Last active',
    sessionRevoked: 'Session Revoked',
    deviceHasBeenSignedOut: 'The device has been signed out.',
    failedToLoadSessions: 'Failed to load sessions',
    procurement: 'Procurement',
    procurementSubtitle: 'End-to-end procurement management — from request to payment',
    warehouse: 'Warehouse',
    warehouseSubtitle: 'Inventory tracking, stock movements & warehouse locations',
    sales: 'Sales',
    salesSubtitle: 'Manage customers, orders, invoices & revenue analytics',
    salesDashboard: 'Dashboard',
    salesOrders: 'Orders',
    salesInvoices: 'Invoices',
    customers: 'Customers',
    addCustomer: 'Add Customer',
    editCustomer: 'Edit Customer',
    noCustomers: 'No customers yet',
    taxNumber: 'Tax Number',
    companyName: 'Company Name',
    address: 'Address',
    city: 'City',
    create: 'Create',
    customer: 'Customer',
    newOrder: 'New Order',
    editOrder: 'Edit Order',
    noOrders: 'No orders yet',
    orderDate: 'Order Date',
    deliveryDate: 'Delivery Date',
    taxRate: 'Tax Rate',
    shippingAddress: 'Shipping Address',
    lineItems: 'Line Items',
    totalRevenue: 'Total Revenue',
    pendingRevenue: 'Pending Revenue',
    activeOrders: 'Active Orders',
    totalCustomers: 'Total Customers',
    totalInvoices: 'Total Invoices',
    overdueInvoices: 'Overdue Invoices',
    monthlyRevenue: 'Monthly Revenue',
    orderPipeline: 'Order Pipeline',
    topCustomers: 'Top Customers',
    receivable: 'Receivable',
    collected: 'Collected',
    noInvoices: 'No invoices yet',
    invoiceDate: 'Invoice Date',
    dueDate: 'Due Date',
    quotations: 'Quotations',
    newQuotation: 'New Quotation',
    editQuotation: 'Edit Quotation',
    createQuotation: 'Create Quotation',
    noQuotations: 'No quotations yet',
    totalQuotations: 'Total Quotations',
    pipelineValue: 'Pipeline Value',
    quotationDate: 'Quotation Date',
    validUntil: 'Valid Until',
    discountPercent: 'Discount',
    termsConditions: 'Terms & Conditions',
  },
  
  ar: {
    // Navigation
    dashboard: 'لوحة التحكم',
    operationsCenter: 'مركز العمليات',
    dailyTasks: 'المهام اليومية',
    fleetTracker: 'تتبع الأسطول',
    fleetCommand: 'قيادة الأسطول',
    companyInfo: 'معلومات الشركة',
    portals: 'البوابات',
    messenger: 'الرسائل',
    vacation: 'الإجازات',
    leaveApprovals: 'موافقات الإجازات',
    importCSV: 'استيراد CSV',
    downloadTemplate: 'تحميل القالب',
    bulkImport: 'استيراد بالجملة',
    profile: 'الملف الشخصي',
    activityLog: 'سجل النشاط',
    monthlyPO: 'أوامر الشراء الشهرية',
    timesheets: 'الجداول الزمنية',
    selfService: 'الخدمة الذاتية',
    shifts: 'جدول المناوبات',
    announcements: 'الإعلانات',
    nurseDocs: 'مستندات الممرضات',
    doctorDocs: 'مستندات الأطباء',
    driverDocs: 'مستندات السائقين',
    reports: 'التقارير',
    hr: 'الموارد البشرية',
    signOut: 'تسجيل الخروج',
    home: 'الرئيسية',
    back: 'رجوع',
    
    // Dashboard
    welcomeBack: 'مرحباً بعودتك',
    totalContracts: 'إجمالي العقود',
    activeContracts: 'العقود النشطة',
    totalValue: 'القيمة الإجمالية',
    purchaseOrders: 'أوامر الشراء',
    pendingOrders: 'الطلبات المعلقة',
    expiringContracts: 'العقود المنتهية قريباً',
    recentActivity: 'النشاط الأخير',
    overview: 'نظرة عامة',
    analytics: 'التحليلات',
    dashboardSubtitle: 'راقب عملياتك بنظرة واحدة',
    contractsTrend: 'اتجاه العقود',
    valueDistribution: 'توزيع القيمة',
    healthOverview: 'نظرة عامة على الصحة',
    monthlyComparison: 'المقارنة الشهرية',
    quickStats: 'إحصائيات سريعة',
    
    // Operations Center
    contracts: 'العقود',
    addContract: 'إضافة عقد',
    editContract: 'تعديل العقد',
    deleteContract: 'حذف العقد',
    contractDetails: 'تفاصيل العقد',
    company: 'الشركة',
    contactName: 'اسم جهة الاتصال',
    contactEmail: 'البريد الإلكتروني',
    startDate: 'تاريخ البداية',
    endDate: 'تاريخ النهاية',
    status: 'الحالة',
    health: 'الصحة',
    value: 'القيمة',
    actions: 'الإجراءات',
    operationsCenterDesc: 'إدارة العقود وأوامر الشراء بدقة مؤسسية',
    contractManagement: 'إدارة العقود',
    contractsRegistered: 'عقود مسجلة',
    newContract: 'عقد جديد',
    newContractEntry: 'إدخال عقد جديد',
    identification: 'التعريف',
    serialNumber: 'الرقم التسلسلي',
    idCode: 'رمز التعريف',
    contact: 'جهة الاتصال',
    dates: 'التواريخ',
    valueSar: 'القيمة (ريال)',
    document: 'المستند',
    uploadDocument: 'رفع مستند',
    noDocument: 'لا يوجد مستند مرفق',
    exportCsv: 'تصدير CSV',
    viewDetails: 'عرض التفاصيل',
    closeDetails: 'إغلاق التفاصيل',
    
    // Purchase Orders
    addPurchaseOrder: 'إضافة أمر شراء',
    vendorParty: 'المورد',
    siteLocation: 'موقع العمل',
    contactInfo: 'معلومات الاتصال',
    locationType: 'نوع الموقع',
    purchaseOrderManagement: 'أوامر الشراء',
    ordersRegistered: 'أوامر مسجلة',
    newPo: 'أمر شراء جديد',
    newPurchaseOrder: 'أمر شراء جديد',
    vendorInformation: 'معلومات المورد',
    locationStatus: 'الموقع والحالة',
    category: 'الفئة',
    
    // Fleet Tracker
    fleetOverview: 'نظرة عامة على الأسطول',
    totalFleet: 'إجمالي الأسطول',
    activeUnits: 'الوحدات النشطة',
    standbyUnits: 'وحدات الاستعداد',
    utilization: 'نسبة الاستخدام',
    searchResources: 'البحث في الموارد...',
    allTypes: 'جميع الأنواع',
    allStatuses: 'جميع الحالات',
    realTimeTracking: 'تتبع الموارد في الوقت الحقيقي والتعبئة',
    live: 'مباشر',
    deployResource: 'نشر مورد',
    totalResources: 'إجمالي الموارد',
    activeDeployed: 'نشط / منشور',
    onStandby: 'في الاستعداد',
    realtimeSync: 'مزامنة فورية',
    deployNewResource: 'نشر مورد جديد',
    resourceType: 'نوع المورد',
    nameId: 'الاسم / المعرف',
    assignment: 'التكليف',
    latitude: 'خط العرض',
    longitude: 'خط الطول',
    dragToUpdate: 'منطقة السعودية • اسحب العلامات لتحديث المواقع',
    
    // Fleet Command
    personnelManagement: 'إدارة الموظفين',
    drilling: 'الحفر',
    construction: 'البناء',
    marineSupport: 'السفن',
    onshore: 'بري',
    offshore: 'بحري',
    addPersonnel: 'إضافة موظف',
    editPersonnel: 'تعديل الموظف',
    name: 'الاسم',
    idNumber: 'رقم الهوية',
    role: 'الدور',
    shift: 'الوردية',
    dayShift: 'وردية نهارية',
    nightShift: 'وردية ليلية',
    certificationStatus: 'حالة الشهادة',
    approved: 'معتمد',
    nonApproved: 'غير معتمد',
    mobilizationDate: 'تاريخ التعبئة',
    demobilizationDate: 'تاريخ التسريح',
    mobilized: 'معبأ',
    demobilized: 'مسرح',
    personnelTimeline: 'نظام إدارة الموظفين والجداول الزمنية',
    tableView: 'جدول',
    timelineView: 'الجدول الزمني',
    searchNameIdRole: 'بحث بالاسم، الهوية، الدور...',
    allShifts: 'جميع الورديات',
    allStatus: 'جميع الحالات',
    clear: 'مسح',
    refresh: 'تحديث',
    commandCenter: 'مركز القيادة',
    headcountByShift: 'عدد الموظفين حسب الوردية',
    recentMobilizations: 'التعبئات الأخيرة',
    
    // Messenger
    messages: 'الرسائل',
    typeMessage: 'اكتب رسالة...',
    online: 'متصل',
    offline: 'غير متصل',
    onlineUsers: 'المستخدمون المتصلون',
    noMessages: 'لا توجد رسائل',
    startConversation: 'ابدأ محادثة',
    searchUsers: 'البحث عن مستخدمين...',
    searchConversations: 'البحث في المحادثات...',
    welcomeToMessenger: 'مرحباً بك في الرسائل',
    selectConversation: 'اختر محادثة من القائمة أو ابدأ محادثة جديدة للتواصل مع جهات اتصالك.',
    startNewChat: 'محادثة جديدة',
    muteNotifications: 'كتم الإشعارات',
    unmuteNotifications: 'تفعيل الإشعارات',
    chatWallpaper: 'خلفية المحادثة',
    sendMessage: 'إرسال رسالة',
    voiceMessage: 'رسالة صوتية',
    attachFile: 'إرفاق ملف',
    shareLocation: 'مشاركة الموقع',
    replyTo: 'الرد على',
    forwardMessage: 'إعادة توجيه',
    deleteMessage: 'حذف الرسالة',
    editMessage: 'تعديل الرسالة',
    starMessage: 'تمييز الرسالة',
    copyMessage: 'نسخ الرسالة',
    
    // Profile
    accountSettings: 'إعدادات الحساب',
    username: 'اسم المستخدم',
    email: 'البريد الإلكتروني',
    changePassword: 'تغيير كلمة المرور',
    currentPassword: 'كلمة المرور الحالية',
    newPassword: 'كلمة المرور الجديدة',
    confirmPassword: 'تأكيد كلمة المرور',
    twoFactorAuth: 'المصادقة الثنائية',
    deleteAccount: 'حذف الحساب',
    signOutAllDevices: 'تسجيل الخروج من جميع الأجهزة',
    profileSettings: 'إعدادات الملف الشخصي',
    securitySettings: 'إعدادات الأمان',
    notificationSettings: 'إعدادات الإشعارات',
    updateProfile: 'تحديث الملف الشخصي',
    uploadAvatar: 'رفع صورة',
    removeAvatar: 'إزالة الصورة',
    activeSessions: 'الجلسات النشطة',
    sessionManagement: 'إدارة الجلسات',
    
    // Vacation & Leave
    vacationRequests: 'طلبات الإجازة',
    requestVacation: 'طلب إجازة',
    newVacationRequest: 'طلب إجازة جديد',
    leaveType: 'نوع الإجازة',
    annual: 'سنوية',
    sick: 'مرضية',
    emergency: 'طارئة',
    reason: 'السبب',
    numberOfDays: 'عدد الأيام',
    daysRemaining: 'الأيام المتبقية',
    daysUsed: 'الأيام المستخدمة',
    totalDays: 'إجمالي الأيام',
    leaveBalance: 'رصيد الإجازات',
    approvedRequests: 'الطلبات المعتمدة',
    pendingRequests: 'الطلبات المعلقة',
    declinedRequests: 'الطلبات المرفوضة',
    managerNotes: 'ملاحظات المدير',
    approve: 'موافقة',
    decline: 'رفض',
    submitRequest: 'تقديم الطلب',
    cancelRequest: 'إلغاء الطلب',
    viewRequest: 'عرض الطلب',
    requestDetails: 'تفاصيل الطلب',
    requestedBy: 'مقدم الطلب',
    requestedOn: 'تاريخ الطلب',
    reviewedBy: 'تمت المراجعة بواسطة',
    reviewedOn: 'تاريخ المراجعة',
    
    // Timesheets
    timesheetManagement: 'إدارة الجداول الزمنية',
    submitTimesheet: 'تقديم الجدول الزمني',
    viewTimesheet: 'عرض الجدول الزمني',
    timesheetPeriod: 'فترة الجدول الزمني',
    hoursWorked: 'ساعات العمل',
    overtime: 'العمل الإضافي',
    regularHours: 'الساعات العادية',
    totalHours: 'إجمالي الساعات',
    timesheetStatus: 'حالة الجدول الزمني',
    submitted: 'مقدم',
    underReview: 'قيد المراجعة',
    rejected: 'مرفوض',
    notes: 'ملاحظات',
    attachments: 'المرفقات',
    downloadTimesheet: 'تحميل الجدول الزمني',
    uploadTimesheet: 'رفع الجدول الزمني',
    
    // Daily Tasks
    dailyWorkPlan: 'خطة العمل اليومية',
    addTask: 'إضافة مهمة',
    editTask: 'تعديل المهمة',
    deleteTask: 'حذف المهمة',
    taskDetails: 'تفاصيل المهمة',
    clientName: 'اسم العميل',
    clientContact: 'جهة اتصال العميل',
    subject: 'الموضوع',
    deadline: 'الموعد النهائي',
    assignedTo: 'مسند إلى',
    priority: 'الأولوية',
    high: 'عالية',
    medium: 'متوسطة',
    low: 'منخفضة',
    taskStatus: 'حالة المهمة',
    inProgress: 'قيد التنفيذ',
    onHold: 'معلق',
    won: 'فاز',
    quotation: 'عرض سعر',
    siteVisit: 'زيارة موقع',
    officeWork: 'عمل مكتبي',
    meeting: 'اجتماع',
    quotationValue: 'قيمة العرض',
    quotationReference: 'مرجع العرض',
    quoteStatus: 'حالة العرض',
    sent: 'مرسل',
    closed: 'مغلق',
    accepted: 'مقبول',
    waiting: 'في الانتظار',
    participated: 'شارك',
    taskNumber: 'رقم المهمة',
    dateCompleted: 'تاريخ الإنجاز',
    reminder: 'تذكير',
    
    // Monthly PO
    monthlyPoTracking: 'تتبع أوامر الشراء الشهرية',
    addTrack: 'إضافة مسار',
    editTrack: 'تعديل المسار',
    deleteTrack: 'حذف المسار',
    serviceName: 'اسم الخدمة',
    locationName: 'اسم الموقع',
    quantity: 'الكمية',
    poNumber: 'رقم أمر الشراء',
    buyerName: 'اسم المشتري',
    buyerEmail: 'بريد المشتري',
    sentToFinance: 'مرسل للمالية',
    justification: 'المبرر',
    month: 'الشهر',
    year: 'السنة',
    calendarView: 'عرض التقويم',
    gridView: 'عرض الشبكة',
    poFile: 'ملف أمر الشراء',
    timesheetFile: 'ملف الجدول الزمني',
    
    // Activity Log
    activityHistory: 'سجل النشاط',
    action: 'الإجراء',
    tableName: 'اسم الجدول',
    recordId: 'معرف السجل',
    oldData: 'البيانات القديمة',
    newData: 'البيانات الجديدة',
    timestamp: 'الوقت',
    performedBy: 'بواسطة',
    insert: 'إضافة',
    update: 'تحديث',
    
    // Company Documents
    companyDocuments: 'وثائق الشركة',
    documentName: 'اسم المستند',
    issuedDate: 'تاريخ الإصدار',
    expiryDate: 'تاريخ الانتهاء',
    documentStatus: 'حالة المستند',
    documentHealth: 'صحة المستند',
    uploadFile: 'رفع ملف',
    viewFile: 'عرض الملف',
    downloadFile: 'تحميل الملف',
    
    // Portal Users
    portalUsers: 'مستخدمو البوابات',
    websiteUrl: 'رابط الموقع',
    password: 'كلمة المرور',
    showPassword: 'إظهار كلمة المرور',
    hidePassword: 'إخفاء كلمة المرور',
    copyPassword: 'نسخ كلمة المرور',
    government: 'حكومي',
    private: 'خاص',
    
    // Common
    save: 'حفظ',
    cancel: 'إلغاء',
    delete: 'حذف',
    edit: 'تعديل',
    add: 'إضافة',
    search: 'بحث',
    filter: 'تصفية',
    export: 'تصدير',
    import: 'استيراد',
    loading: 'جاري التحميل...',
    noData: 'لا توجد بيانات',
    success: 'نجاح',
    error: 'خطأ',
    warning: 'تحذير',
    confirm: 'تأكيد',
    yes: 'نعم',
    no: 'لا',
    close: 'إغلاق',
    submit: 'إرسال',
    reset: 'إعادة تعيين',
    apply: 'تطبيق',
    selectAll: 'تحديد الكل',
    deselectAll: 'إلغاء تحديد الكل',
    showMore: 'عرض المزيد',
    showLess: 'عرض أقل',
    viewAll: 'عرض الكل',
    noResults: 'لا توجد نتائج',
    tryAgain: 'حاول مرة أخرى',
    goBack: 'رجوع',
    next: 'التالي',
    previous: 'السابق',
    first: 'الأول',
    last: 'الأخير',
    page: 'صفحة',
    of: 'من',
    items: 'عناصر',
    selected: 'محدد',
    all: 'الكل',
    none: 'لا شيء',
    
    // Status
    valid: 'ساري',
    expired: 'منتهي',
    healthy: 'صحي',
    atRisk: 'معرض للخطر',
    critical: 'حرج',
    active: 'نشط',
    standby: 'استعداد',
    pending: 'قيد الانتظار',
    completed: 'مكتمل',
    overdue: 'متأخر',
    
    // Roles & Fleet Types
    nurse: 'ممرض',
    doctor: 'طبيب',
    clinic: 'عيادة',
    driver: 'سائق',
    ambulance: 'إسعاف',
    management: 'الإدارة',
    operations: 'العمليات',
    declined: 'مرفوض',
    
    // Time
    today: 'اليوم',
    yesterday: 'أمس',
    lastWeek: 'الأسبوع الماضي',
    lastMonth: 'الشهر الماضي',
    thisMonth: 'هذا الشهر',
    thisYear: 'هذه السنة',
    dateRange: 'نطاق التاريخ',
    from: 'من',
    to: 'إلى',
    
    // Auth
    signIn: 'تسجيل الدخول',
    signUp: 'إنشاء حساب',
    forgotPassword: 'نسيت كلمة المرور؟',
    rememberMe: 'تذكرني',
    welcomeTo: 'مرحباً بك في',
    enterprise: 'المؤسسة',
    workManagement: 'إدارة العمل',
    fleetPersonnel: 'الأسطول والموظفين',
    companyAdmin: 'الشركة والإدارة',
    employeeHub: 'بوابة الموظف',
    createAccount: 'إنشاء حساب',
    alreadyHaveAccount: 'لديك حساب بالفعل؟',
    dontHaveAccount: 'ليس لديك حساب؟',
    resetPassword: 'إعادة تعيين كلمة المرور',
    sendResetLink: 'إرسال رابط إعادة التعيين',
    backToLogin: 'العودة لتسجيل الدخول',
    verifyEmail: 'تأكيد البريد الإلكتروني',
    resendCode: 'إعادة إرسال الرمز',
    enterCode: 'أدخل الرمز',
    trustThisDevice: 'الوثوق بهذا الجهاز',
    
    // Notifications
    notifications: 'الإشعارات',
    markAsRead: 'تحديد كمقروء',
    markAllAsRead: 'تحديد الكل كمقروء',
    clearAll: 'مسح الكل',
    noNotifications: 'لا توجد إشعارات',
    newNotification: 'إشعار جديد',
    
    // Errors
    somethingWentWrong: 'حدث خطأ ما',
    pageNotFound: 'الصفحة غير موجودة',
    accessDenied: 'الوصول مرفوض',
    sessionExpired: 'انتهت الجلسة',
    networkError: 'خطأ في الشبكة',
    pleaseTryAgain: 'يرجى المحاولة مرة أخرى',
    
    // Success Messages
    savedSuccessfully: 'تم الحفظ بنجاح',
    deletedSuccessfully: 'تم الحذف بنجاح',
    updatedSuccessfully: 'تم التحديث بنجاح',
    createdSuccessfully: 'تم الإنشاء بنجاح',
    
    // Dashboard Extended
    enterpriseIntelligence: 'الذكاء المؤسسي',
    realTimeAnalytics: 'تحليلات في الوقت الفعلي ورؤى لاتخاذ قرارات مدروسة',
    totalContractValue: 'إجمالي قيمة العقود',
    totalPOValue: 'إجمالي قيمة أوامر الشراء',
    purchaseOrderTrends: 'اتجاهات أوامر الشراء',
    lastSixMonths: 'أداء آخر 6 أشهر',
    contractHealthTitle: 'صحة العقود',
    currentStatusOverview: 'نظرة عامة على الوضع الحالي',
    timesheetReview: 'مراجعة الجداول الزمنية',
    overallReviewStatus: 'حالة المراجعة الشاملة',
    approvalRate: 'معدل الموافقة',
    noTrendData: 'لا توجد بيانات اتجاه',
    noContractData: 'لا توجد بيانات عقود',
    total: 'الإجمالي',
    
    // Monthly PO Extended
    monthlyPurchaseOrderPlanner: 'مخطط أوامر الشراء الشهرية',
    masterPlanningGrid: 'شبكة التخطيط الرئيسية لتتبع أوامر الشراء عبر جميع المواقع والخدمات',
    totalLocations: 'إجمالي المواقع',
    missingPoAlerts: 'تنبيهات أوامر الشراء المفقودة',
    sharedWithFinance: 'مشترك مع المالية',
    searchPlaceholder: 'بحث في الموقع، الخدمة، الشركة، أو رقم أمر الشراء...',
    allLocations: 'جميع المواقع',
    missingPoFile: 'ملف أمر الشراء مفقود',
    pendingFinance: 'بانتظار المالية',
    clearFilters: 'مسح الفلاتر',
    noDataToExport: 'لا توجد بيانات للتصدير',
    excelDownloaded: 'تم تحميل ملف Excel',
    pdfOpened: 'تم فتح PDF للطباعة',
    
    // Vacation Extended
    myVacation: 'إجازتي',
    manageTimeOff: 'إدارة طلبات إجازتك',
    newRequest: 'طلب جديد',
    daysAway: 'أيام متبقية',
    noUpcomingLeave: 'لا توجد إجازة قادمة',
    requestHistory: 'سجل الطلبات',
    noVacationHistory: 'لا يوجد سجل إجازات',
    noVacationRequestsYet: 'لم تقدم أي طلبات إجازة بعد.',
    submitFirstRequest: 'قدم طلبك الأول',
    awaitingApproval: 'بانتظار الموافقة',
    nextLeave: 'الإجازة القادمة',
    days: 'أيام',
    cancelVacationRequest: 'إلغاء طلب الإجازة؟',
    keepRequest: 'الاحتفاظ بالطلب',
    cancelling: 'جاري الإلغاء...',
    requestCancelled: 'تم إلغاء الطلب',
    vacationRequestCancelled: 'تم إلغاء طلب إجازتك.',
    
    // Confirmations
    areYouSure: 'هل أنت متأكد؟',
    thisActionCannotBeUndone: 'لا يمكن التراجع عن هذا الإجراء',
    confirmDelete: 'تأكيد الحذف',
    confirmAction: 'تأكيد الإجراء',
    
    // Contracts Module
    totalContractValueKpi: 'إجمالي قيمة العقود',
    expiringSoon: 'ينتهي قريباً',
    pendingRenewals: 'بانتظار التجديد',
    timeline: 'الجدول الزمني',
    needsReview: 'يحتاج مراجعة',
    expiringLabel: 'ينتهي قريباً',
    contractsLabel: 'عقود',
    fromLastMonth: 'من الشهر الماضي',
    
    // Purchase Orders Module
    totalOrderValue: 'إجمالي قيمة الطلبات',
    pendingFulfillment: 'بانتظار التنفيذ',
    invoicedPaid: 'مفوتر / مدفوع',
    totalPoValue: 'إجمالي قيمة أوامر الشراء',
    ordersLabel: 'طلبات',
    fulfillment: 'التنفيذ',
    vendor: 'المورد',
    type: 'النوع',
    doc: 'المستند',
    
    // Timesheets Extended
    pendingTimesheets: 'قيد الانتظار',
    historyTimesheets: 'السجل',
    allTimesheets: 'الكل',
    overdueTimesheets: 'متأخر',
    timesheetApproved: 'معتمد',
    timesheetRejected: 'مرفوض',
    timesheetPending: 'قيد الانتظار',
    resetToPending: 'إعادة للانتظار',
    resource: 'المورد',
    period: 'الفترة',
    receivedOn: 'تاريخ الاستلام',
    requestHelp: 'طلب مساعدة',
    manualRequest: 'طلب يدوي',
    selectResource: 'اختر المورد',
    selectType: 'اختر النوع',
    monthlyCycle: 'دورة شهرية',
    demobilization: 'تسريح',
    filterByRole: 'تصفية حسب الدور',
    helpDescription: 'يرجى وصف مشكلتك أو طلبك بالتفصيل.',
    phone: 'الهاتف',
    
    // Daily Tasks Extended
    dailyTaskWorkPlan: 'المهام اليومية وخطة العمل',
    manageTrackTasks: 'إدارة وتتبع جميع المهام والعروض والتكليفات',
    criticalTasks: 'المهام الحرجة',
    quotationPipeline: 'خط العروض',
    completionRate: 'معدل الإنجاز',
    totalActiveTasks: 'إجمالي المهام النشطة',
    urgent: 'عاجل',
    allClear: 'كل شيء على ما يرام',
    onTrack: 'في المسار الصحيح',
    needsAttention: 'يحتاج اهتمام',
    totalLabel: 'الإجمالي',
    searchTasksCompanies: 'بحث في المهام، الشركات، أو المعرفات...',
    filterByStatus: 'تصفية حسب الحالة',
    filterByAssignee: 'تصفية حسب المسند إليه',
    allAssignees: 'جميع المسندين',
    noTasksFound: 'لا توجد مهام',
    createFirstTask: 'أنشئ مهمتك الأولى',
    taskId: 'معرف المهمة',
    taskInfo: 'معلومات المهمة',
    daysLeft: 'الأيام المتبقية',
    files: 'الملفات',
    loadingTasks: 'جاري تحميل المهام...',
    table: 'جدول',
    kanban: 'كانبان',
    unassigned: 'غير مسند',
    
    // Fleet Resources Extended
    fleetResources: 'موارد الأسطول',
    manageFleetResources: 'إدارة وإضافة موارد الأسطول',
    addResource: 'إضافة مورد',
    editResource: 'تعديل المورد',
    addNewResource: 'إضافة مورد جديد',
    resourceAdded: 'تمت الإضافة',
    newFleetResourceAdded: 'تم إضافة مورد أسطول جديد.',
    resourceUpdated: 'تم التحديث',
    fleetResourceUpdated: 'تم تحديث مورد الأسطول.',
    resourceRemoved: 'تمت الإزالة',
    fleetResourceRemoved: 'تم إزالة مورد الأسطول.',
    confirmDeleteResource: 'هل أنت متأكد من حذف هذا المورد؟',
    statusUpdated: 'تم تحديث الحالة',
    resourceNow: 'المورد الآن',
    validationError: 'خطأ في التحقق',
    allResources: 'جميع الموارد',
    noMatchingResources: 'لا توجد موارد مطابقة',
    noResourcesYet: 'لم تتم إضافة موارد بعد',
    noResourcesDeployed: 'لم يتم نشر موارد',
    detailsLabel: 'التفاصيل',
    detailsAssignment: 'التفاصيل / التكليف',
    optional: 'اختياري',
    egDrSmith: 'مثال: د. أحمد',
    egSiteAlpha: 'مثال: موقع ألفا',
    updateResource: 'تحديث المورد',
    deployedResources: 'الموارد المنشورة',
    personnelAssigned: 'الموظفون',
    noPersonnelAssigned: 'لا يوجد موظفون معينون',
    lastUpdated: 'آخر تحديث',

    // Auth & Security extended
    securityCheckRequired: 'مطلوب التحقق الأمني',
    pleaseCompleteRecaptcha: 'يرجى إكمال التحقق من reCAPTCHA',
    securityCheckFailed: 'فشل التحقق الأمني',
    recaptchaVerifyFailed: 'فشل التحقق من reCAPTCHA. يرجى المحاولة مرة أخرى.',
    unableToVerifyRecaptcha: 'تعذر التحقق من reCAPTCHA. يرجى المحاولة مرة أخرى.',
    pleaseEnterValidEmail: 'يرجى إدخال بريد إلكتروني صحيح',
    invalidUsernameTitle: 'اسم مستخدم غير صالح',
    tooManyAttempts: 'محاولات كثيرة',
    loginFailed: 'فشل تسجيل الدخول',
    welcomeBackToast: 'مرحباً بعودتك!',
    signedInTrustedDevice: 'تم تسجيل الدخول من جهاز موثوق.',
    twoFARequired: 'المصادقة الثنائية مطلوبة',
    enterCodeFromAuthenticator: 'أدخل الرمز من تطبيق المصادقة',
    youHaveSuccessfullyLoggedIn: 'تم تسجيل دخولك بنجاح.',
    signUpFailed: 'فشل إنشاء الحساب',
    accountCreated: 'تم إنشاء الحساب!',
    signedInAutomatically: 'تم تسجيل دخولك تلقائياً.',
    deviceRemembered: 'تم تذكر الجهاز',
    no2FAFor30Days: 'لن تحتاج المصادقة الثنائية على هذا الجهاز لمدة 30 يوماً.',
    unexpectedErrorOccurred: 'حدث خطأ غير متوقع',
    accessYourAccount: 'الوصول إلى حسابك',
    createAccountHeading: 'إنشاء حساب',
    enterCredentialsToContinue: 'أدخل بياناتك للمتابعة',
    fillDetailsToGetStarted: 'أدخل التفاصيل للبدء',
    warningAttemptsRemaining: 'تحذير: متبقي {count} محاولة قبل القفل',
    yourUsername: 'اسم المستخدم',
    emailAddressLabel: 'البريد الإلكتروني',
    emailPlaceholderExample: 'you@company.com',
    slideToSignIn: 'اسحب لتسجيل الدخول',
    createAccountButton: 'إنشاء حساب',
    dontHaveAccountSignUp: 'ليس لديك حساب؟',
    alreadyHaveAccountSignIn: 'لديك حساب بالفعل؟',
    enterpriseExcellence: 'التميز المؤسسي',
    secureIntelligentModern: 'آمن ذكي حديث',
    secureManagementSubtitle: 'إدارة آمنة وذكية للعقود وأوامر الشراء وعمليات الأسطول.',
    returnToHome: 'العودة للرئيسية',

    // 2FA Verify
    twoFactorAuthTitle: 'المصادقة الثنائية',
    enterBackupCode: 'أدخل أحد رموز النسخ الاحتياطي',
    enter6DigitCode: 'أدخل الرمز المكون من 6 أرقام من تطبيق المصادقة',
    codeRefreshesIn: 'يتجدد الرمز خلال',
    openAuthenticatorApp: 'افتح تطبيق المصادقة (Google Authenticator، Authy، إلخ) للحصول على الرمز.',
    enterBackupCodesSaved: 'أدخل أحد رموز النسخ الاحتياطي التي حفظتها عند إعداد المصادقة الثنائية.',
    rememberDevice30Days: 'تذكر هذا الجهاز لمدة 30 يوماً',
    verifyAndSignIn: 'تحقق وتسجيل الدخول',
    useAuthenticatorCode: 'استخدام رمز المصادقة',
    useBackupCode: 'استخدام رمز النسخ الاحتياطي',
    verified: 'تم التحقق!',
    backupCodeUsedGenerateNew: 'تم استخدام رمز النسخ الاحتياطي. يُنصح بإنشاء رموز جديدة.',
    invalidCode: 'رمز غير صالح',
    pleaseCheckCodeTryAgain: 'يرجى التحقق من الرمز والمحاولة مرة أخرى',
    tooManyAttemptsTryAgainLater: 'يرجى المحاولة لاحقاً',

    // 2FA Setup
    notAuthenticated: 'غير مصادق',
    twoFASetupStarted: 'بدء إعداد المصادقة الثنائية',
    scanQRWithAuthenticator: 'امسح رمز QR بتطبيق المصادقة',
    twoFAEnabledToast: 'تم تفعيل المصادقة الثنائية!',
    twoFactorNowActive: 'المصادقة الثنائية مفعلة الآن على حسابك',
    invalidCodeCheckAuthenticator: 'يرجى التحقق من تطبيق المصادقة والمحاولة مرة أخرى',
    twoFADisabled: 'تم تعطيل المصادقة الثنائية',
    twoFARemovedFromAccount: 'تم إزالة المصادقة الثنائية من حسابك',
    copied: 'تم النسخ!',
    backupCodesCopiedToClipboard: 'تم نسخ رموز النسخ الاحتياطي',
    enabledAndProtecting: '✓ مفعلة وتحمي حسابك',
    disable: 'تعطيل',
    disableTwoFactorQuestion: 'تعطيل المصادقة الثنائية؟',
    disable2FADescription: 'سيؤدي هذا إلى إزالة طبقة أمان مهمة. أي شخص يعرف كلمة المرور سيتمكن من الوصول لحسابك.',
    yesDisable2FA: 'نعم، تعطيل المصادقة الثنائية',
    copyBackupCodesLabel: 'نسخ رموز النسخ الاحتياطي',
    setupAuthenticatorApp: 'إعداد تطبيق المصادقة',
    scanQRWithGoogleAuthy: 'امسح رمز QR بـ Google Authenticator أو Authy',
    cantScanEnterManually: 'لا تستطيع المسح؟ أدخل هذا الرمز يدوياً:',
    saveYourBackupCodes: 'احفظ رموز النسخ الاحتياطي',
    copyAll: 'نسخ الكل',
    storeBackupCodesSafely: 'احفظ هذه الرموز بأمان. كل رمز يُستخدم مرة واحدة فقط إذا فقدت الوصول لتطبيق المصادقة.',
    enter6DigitToVerify: 'أدخل الرمز المكون من 6 أرقام من تطبيق المصادقة للتحقق:',
    verifyAndEnable: 'تحقق وتفعيل',
    addExtraLayerSecurity: 'إضافة طبقة أمان إضافية مع TOTP',
    enable2FA: 'تفعيل المصادقة الثنائية',

    // Forgot password
    pleaseCompleteSecurityVerification: 'يرجى إكمال التحقق الأمني',
    securityVerificationFailed: 'فشل التحقق الأمني. يرجى المحاولة مرة أخرى.',
    unableToVerifySecurityCheck: 'تعذر التحقق الأمني. يرجى المحاولة مرة أخرى.',
    emailSent: 'تم إرسال البريد',
    checkInboxForResetLink: 'تحقق من صندوق الوارد لرابط إعادة تعيين كلمة المرور.',
    failedToSendResetEmail: 'فشل إرسال بريد إعادة التعيين',
    checkYourEmail: 'تحقق من بريدك',
    ifAccountExistsResetLink: 'إذا وُجد حساب بهذا البريد، ستستلم رابط إعادة التعيين قريباً.',
    enterEmailResetLink: 'أدخل بريدك الإلكتروني وسنرسل لك رابط إعادة تعيين كلمة المرور.',

    // Reset password page
    invalidOrExpiredResetLink: 'رابط غير صالح أو منتهي. يرجى طلب إعادة تعيين جديدة.',
    passwordsDoNotMatch: 'كلمات المرور غير متطابقة',
    passwordUpdated: 'تم تحديث كلمة المرور',
    passwordResetSuccessfully: 'تم إعادة تعيين كلمة المرور بنجاح',
    youWillBeRedirected: 'سيتم توجيهك لصفحة تسجيل الدخول قريباً.',
    resetYourPassword: 'إعادة تعيين كلمة المرور',
    enterNewPasswordBelow: 'أدخل كلمة المرور الجديدة أدناه',
    min8CharsPassword: '8 أحرف على الأقل مع حرف كبير وصغير ورقم',
    failedToResetPassword: 'فشل إعادة تعيين كلمة المرور',

    // NotFound
    oopsPageNotFound: 'عذراً! الصفحة غير موجودة',

    // Profile extended
    pleaseSelectImageFile: 'يرجى اختيار ملف صورة',
    imageMustBeLessThan2MB: 'يجب أن تكون الصورة أقل من 2 ميجابايت',
    avatarUpdated: 'تم تحديث الصورة',
    profilePictureUpdated: 'تم تحديث صورة الملف الشخصي.',
    avatarRemoved: 'تم إزالة الصورة',
    profilePictureRemoved: 'تم إزالة صورة الملف الشخصي.',
    usernameCannotBeEmpty: 'اسم المستخدم لا يمكن أن يكون فارغاً',
    profileUpdated: 'تم تحديث الملف',
    profileSavedSuccessfully: 'تم حفظ الملف الشخصي بنجاح.',
    newPasswordsDoNotMatch: 'كلمات المرور الجديدة غير متطابقة',
    passwordMustBe6Chars: 'كلمة المرور يجب أن تكون 6 أحرف على الأقل',
    passwordChanged: 'تم تغيير كلمة المرور',
    passwordUpdatedSuccessfully: 'تم تحديث كلمة المرور بنجاح.',
    accountDeleted: 'تم حذف الحساب',
    accountPermanentlyDeleted: 'تم حذف حسابك نهائياً.',
    signedOut: 'تم تسجيل الخروج',
    signedOutAllDevices: 'تم تسجيل خروجك من جميع الأجهزة.',
    aiAssistantEnabled: 'تم تفعيل المساعد الذكي',
    aiAssistantDisabled: 'تم تعطيل المساعد الذكي',
    editProfile: 'تعديل الملف الشخصي',
    removePhoto: 'إزالة الصورة',
    securityAndLogin: 'الأمان وتسجيل الدخول',
    updatePasswordRegularly: 'حدّث كلمة المرور بانتظام للبقاء آمناً.',
    enterNewPassword: 'أدخل كلمة المرور الجديدة',
    confirmNewPasswordPlaceholder: 'تأكيد كلمة المرور الجديدة',
    changePasswordButton: 'تغيير كلمة المرور',
    personalInformation: 'المعلومات الشخصية',
    emailCannotBeChanged: 'لا يمكن تغيير البريد الإلكتروني',
    iqamaId: 'رقم الإقامة',
    enterIqamaId: 'أدخل رقم الإقامة',
    requiredForPayrollLeave: 'مطلوب للم payroll وسجلات الإجازة',
    interfacePreferences: 'تفضيلات الواجهة',
    enableAIAssistant: 'تفعيل المساعد الذكي',
    showFloatingAIChat: 'إظهار زر الدردشة الذكية للمساعدة السريعة.',
    deleteAccountLabel: 'حذف الحساب',
    permanentlyRemoveAccount: 'إزالة حسابك وجميع البيانات نهائياً.',
    deleteAccountButton: 'حذف الحساب',
    areYouAbsolutelySure: 'هل أنت متأكد تماماً؟',
    deleteAccountPermanentWarning: 'لا يمكن التراجع عن هذا. سيتم حذف حسابك وجميع بياناتك نهائياً.',
    yesDeleteMyAccount: 'نعم، احذف حسابي',
    signOutAll: 'تسجيل الخروج من الكل',
    logOutFromAllSessions: 'تسجيل الخروج من جميع الجلسات على جميع الأجهزة.',
    activeSessionsTitle: 'الجلسات النشطة',
    your5MostRecentSessions: 'أحدث 5 جلسات نشطة',
    noActiveSessionsFound: 'لا توجد جلسات نشطة',
    currentSession: 'الحالية',
    lastActive: 'آخر نشاط',
    sessionRevoked: 'تم إنهاء الجلسة',
    deviceHasBeenSignedOut: 'تم تسجيل خروج الجهاز.',
    failedToLoadSessions: 'فشل تحميل الجلسات',
    procurement: 'المشتريات',
    procurementSubtitle: 'إدارة المشتريات من الطلب إلى الدفع',
    warehouse: 'المستودع',
    warehouseSubtitle: 'تتبع المخزون وحركات المواد ومواقع المستودعات',
    sales: 'المبيعات',
    salesSubtitle: 'إدارة العملاء والطلبات والفواتير وتحليلات الإيرادات',
    salesDashboard: 'لوحة التحكم',
    salesOrders: 'الطلبات',
    salesInvoices: 'الفواتير',
    customers: 'العملاء',
    addCustomer: 'إضافة عميل',
    editCustomer: 'تعديل عميل',
    noCustomers: 'لا يوجد عملاء بعد',
    taxNumber: 'الرقم الضريبي',
    companyName: 'اسم الشركة',
    address: 'العنوان',
    city: 'المدينة',
    create: 'إنشاء',
    customer: 'العميل',
    newOrder: 'طلب جديد',
    editOrder: 'تعديل الطلب',
    noOrders: 'لا يوجد طلبات بعد',
    orderDate: 'تاريخ الطلب',
    deliveryDate: 'تاريخ التسليم',
    taxRate: 'نسبة الضريبة',
    shippingAddress: 'عنوان الشحن',
    lineItems: 'بنود',
    totalRevenue: 'إجمالي الإيرادات',
    pendingRevenue: 'إيرادات معلقة',
    activeOrders: 'طلبات نشطة',
    totalCustomers: 'إجمالي العملاء',
    totalInvoices: 'إجمالي الفواتير',
    overdueInvoices: 'فواتير متأخرة',
    monthlyRevenue: 'الإيرادات الشهرية',
    orderPipeline: 'خط أنابيب الطلبات',
    topCustomers: 'أفضل العملاء',
    receivable: 'المستحقات',
    collected: 'المحصل',
    noInvoices: 'لا يوجد فواتير بعد',
    invoiceDate: 'تاريخ الفاتورة',
    dueDate: 'تاريخ الاستحقاق',
    quotations: 'عروض الأسعار',
    newQuotation: 'عرض سعر جديد',
    editQuotation: 'تعديل عرض السعر',
    createQuotation: 'إنشاء عرض سعر',
    noQuotations: 'لا يوجد عروض أسعار بعد',
    totalQuotations: 'إجمالي العروض',
    pipelineValue: 'قيمة العروض النشطة',
    quotationDate: 'تاريخ العرض',
    validUntil: 'صالح حتى',
    discountPercent: 'الخصم',
    termsConditions: 'الشروط والأحكام',
  }
} as const;

export type Language = 'en' | 'ar';
export type TranslationKey = keyof typeof translations.en;
